// src/routes/index.tsx
import React, { Suspense, useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useGenerateRoutes } from "@/hooks/useGenerateRoutes";
import { PageContentSkeleton } from "@/components/skeletons";

const RoutesComponent: React.FC = () => {
  const routes = useGenerateRoutes();
  // console.log(routes,"routes");

  const router = useMemo(() => createBrowserRouter(routes), [routes]);

  return (
    <Suspense fallback={<PageContentSkeleton />}>
      <RouterProvider router={router} />
    </Suspense>
  )
};

export default RoutesComponent;
